import React, { useEffect, useRef } from "react"
import gsap from "gsap"
import { FaBolt, FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa"
//Context
import {
  useHomeStateContext,
  useHomeDispatchContext,
} from "../../context/homeContext"
//Components
import VideoPresentation from "./videoPresentation"
import BubbleImagePresentation from "./bubbleImagePresentation"
//Helpers
import { linearFunction } from "../../helpers/mathHelpers"
//Styled Components
import { PresentationWrapper } from "../../styles/homeStyles"

export default function Presentation({ onCursor }) {
  //Constant
  const word1 = "Jose Pio.".split("")
  const word2 = "Frontend".split("")
  const word3 = "Developer".split("")
  //Contexts
  const { toggle } = useHomeStateContext()
  const homeDispatch = useHomeDispatchContext()
  //Refs
  const titleName = useRef(null)
  const containerRef = useRef(null)
  const bgmoveCircle = useRef(null)
  const buttonMagnet = useRef(null)
  //Functions
  const onToggleMode = _ => {
    homeDispatch({
      type: "TOGGLE_LIGHT",
      payload: !toggle,
    })
  }

  const onMagnetOff = e => {
    const bgmove = e.currentTarget.querySelector(".bgmove")
    const borderButton = e.currentTarget.querySelector(".border-button")
    const togLigth = e.currentTarget.querySelector(".toggle-ligth")

    gsap.to(bgmove, {
      duration: 1.5,
      x: 0,
      y: 0,
      ease: "elastic.out(1.2,0.6)",
    })

    gsap.to(borderButton, {
      duration: 1.5,
      x: 0,
      y: 0,
      z: 40,
      scale: 1,
      ease: "elastic.out(1.2,0.6)",
    })

    gsap.to(togLigth, {
      duration: 1.5,
      x: 0,
      y: 0,
      z: 80,
      ease: "elastic.out(1.2,0.6)",
    })
  }

  const onMagnetOn = e => {
    const { clientX, clientY } = e
    const bgmove = e.currentTarget.querySelector(".bgmove")
    const borderButton = e.currentTarget.querySelector(".border-button")
    const togLigth = e.currentTarget.querySelector(".toggle-ligth")

    const rect = e.currentTarget.getBoundingClientRect()
    const offsetWidth = e.currentTarget.offsetWidth
    const offsetHeight = e.currentTarget.offsetHeight
    const diffX = clientX - rect.left
    const diffY = clientY - rect.top

    const x = linearFunction(
      diffX,
      [0, offsetWidth],
      [-offsetWidth / 3, offsetWidth / 3]
    )
    const y = linearFunction(
      diffY,
      [0, offsetHeight],
      [-offsetHeight / 3, offsetHeight / 3]
    )

    gsap.to(bgmove, {
      duration: 1,
      x: x,
      y: y,
      ease: "expo.out",
    })

    gsap.to(borderButton, {
      duration: 1,
      x: x,
      y: y,
      z: 0,
      scale: 1.5,
      ease: "expo.out",
    })

    gsap.to(togLigth, {
      duration: 1,
      x: x,
      y: y + 20,
      z: 0,
      ease: "expo.out",
    })
  }

  const onMove3D = e => {
    const { clientX: x, clientY: y } = e
    const Tx = linearFunction(x, [0, window.innerWidth], [-40, 40])
    const Ty = linearFunction(y, [0, window.innerHeight], [-40, 40])
    const Rx = linearFunction(x, [0, window.innerWidth], [-8, 8])
    const Ry = linearFunction(y, [0, window.innerHeight], [8, -8])

    gsap.to(containerRef.current, {
      duration: 1.5,
      x: Tx,
      y: Ty,
      rotationX: Ry,
      rotationY: Rx,
      overwrite: true,
      ease: "expo.out",
    })

    gsap.to(
      bgmoveCircle.current.querySelector(".bg") ||
        bgmoveCircle.current.querySelector(".bubble-video"),
      {
        duration: 1.5,
        x: -Tx * 2,
        y: -Ty * 2,
        overwrite: true,

        ease: "expo.out",
      }
    )
  }
  //Hooks Effects
  useEffect(() => {
    const presNode = document.querySelector(".presentation-wrapper")
    setTimeout(() => {
      presNode.addEventListener("mousemove", onMove3D)
    }, 1500)

    return () => {
      presNode.removeEventListener("mousemove", onMove3D)
    }
  }, [])

  useEffect(() => {
    const cache = JSON.parse(window.localStorage.getItem("toggle"))
    homeDispatch({
      type: "TOGGLE_LIGHT",
      payload: cache,
    })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    window.localStorage.setItem("toggle", JSON.stringify(toggle))
  }, [toggle])

  return (
    <PresentationWrapper toggle={toggle} className="presentation-wrapper">
      <div className="container" ref={containerRef}>
        <div className="title-name" ref={titleName}>
          <h1 className="contrast">
            <div className="split-parag">
              {word1.map((char, i) => {
                if (char === " ") return " "
                return <span key={`word1-${i}`}>{char}</span>
              })}
            </div>
            <div className="split-parag">
              {word2.map((char, i) => {
                return <span key={`word2-${i}`}>{char}</span>
              })}
            </div>
            <div className="split-parag">
              {word3.map((char, i) => {
                return <span key={`word3-${i}`}>{char}</span>
              })}
            </div>
          </h1>
        </div>
        <div className="wrapper-img">
          <VideoPresentation />
        </div>
        <button
          aria-label="Toggle Light General"
          className="toggle-button"
          ref={buttonMagnet}
          onClick={onToggleMode}
          onMouseMove={onMagnetOn}
          onMouseEnter={() => onCursor("pointer")}
          onMouseLeave={e => {
            onMagnetOff(e)
            onCursor()
          }}
        >
          <span className="border-button"></span>
          <span className="bgmove" ref={bgmoveCircle}>
            <BubbleImagePresentation />
          </span>
          <span className="toggle-ligth">
            <span className="wrapper-toggle">
              <span className="ball">
                <span className="light-wrapp">
                  <FaBolt />
                </span>
              </span>
            </span>
          </span>
        </button>
      </div>
      <div className="social-wrapper">
        <a
          className="social-item-link"
          rel="noreferrer"
          aria-label="Twitter"
          target="_blank"
          href="https://twitter.com/cpioweb"
          onMouseEnter={_ => onCursor("pointer")}
          onMouseLeave={_ => onCursor()}
        >
          <FaTwitter />
        </a>
        <a
          className="social-item-link"
          rel="noreferrer"
          aria-label="Linkedin"
          target="_blank"
          href="https://www.linkedin.com/in/cpio/"
          onMouseEnter={_ => onCursor("pointer")}
          onMouseLeave={_ => onCursor()}
        >
          <FaLinkedin />
        </a>

        <a
          className="social-item-link"
          rel="noreferrer"
          aria-label="Github"
          target="_blank"
          href="https://github.com/cpiocova"
          onMouseEnter={_ => onCursor("pointer")}
          onMouseLeave={_ => onCursor()}
        >
          <FaGithub />
        </a>
      </div>
      <button
        aria-label="Toggle Light Responsive"
        className="light-res"
        onMouseEnter={_ => onCursor("pointer")}
        onMouseLeave={_ => onCursor()}
        onClick={onToggleMode}
      >
        <span className="light-wrapp">
          <FaBolt />
        </span>
      </button>
    </PresentationWrapper>
  )
}
